module.exports = __webpack_public_path__ + "static/hawaii-6-ece37288987fdbc762703e8dbd3a6b4f.png";